<template>
  <div class="card text-center">
    <div class="mx-auto w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
      <span class="text-2xl">✓</span>
    </div>
    <h1 class="text-xl font-semibold mb-2">เข้าร่วมโครงการสำเร็จ</h1>
    <p class="text-slate-600 mb-4">แบบฟอร์มการสมัคร ถูกส่งไปยังอีเมล {{ email }} แล้ว กรุณาตรวจสอบอีเมลของท่าน</p>
    <p class="text-slate-600 mb-6">หากท่านยังไม่ได้รับอีเมล โปรดตรวจสอบใน Junk Mail/Spam ของท่าน</p>
    
  </div>
</template>
<script setup>
import { ref, onMounted  } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const email = ref('') 


onMounted(() => {  
  
  if (route.query.email) {
    email.value = route.query.email
  }
})
</script>